import React from 'react';

import { HeadlineH5, SubtitleST4 } from 'common/components/Typography';
import { useLocalization } from 'common/providers/LocaleProvider';
import helpSkuImage from '../../images/help-sku.png';

export const HelpContentDrawer = () => {
  const { t } = useLocalization();

  return (
    <>
      <HeadlineH5 p="sp_16">{t('h24_contact_form_item_number_drawer_title')}</HeadlineH5>
      <SubtitleST4
        p="sp_16"
        pt="sp_0"
        mb="sp_8"
        dangerouslySetInnerHTML={{
          __html: t('h24_contact_form_item_number_drawer_description'),
        }}
      />
      <img
        src={helpSkuImage.src}
        width="100%"
        alt={t('h24_contact_form_item_number_drawer_title')}
      />
    </>
  );
};
